import { createFeature, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { CommonState } from '@shared/models/common/common-state';
import { DossierFacturable } from '@features/demande-remboursement/choix-dossier/models/dossier-facturable.model';
import { MesDossiersActions } from '@features/demande-remboursement/choix-dossier/store/mes-dossiers/mes-dossiers.actions';
import { DossiersSelectionne } from '@features/demande-remboursement/choix-dossier/models/dossier-selectionne.model';

export const MAX_SIZE_DOSSIERS_SELECTIONNEES = 20;
export interface MesDossierState extends EntityState<DossierFacturable>, CommonState {
  totalElements: number;
  dossiersSelectionnes: DossiersSelectionne[];
  isLoading: boolean;
  isFactureToDelete: boolean;
}

export const entiteAdapter: EntityAdapter<DossierFacturable> = createEntityAdapter<DossierFacturable>({
  selectId: (dossier: DossierFacturable) => dossier.identifiantDossier
});

const initialState: MesDossierState = entiteAdapter.getInitialState({
  totalElements: 0,
  loading: true,
  errorMessage: null,
  dossiersSelectionnes: [],
  isLoading: false,
  isFactureToDelete: false
});

export const mesDossiersReducers = createReducer(
  initialState,
  on(MesDossiersActions.getDossiersBySearchCriteriaSuccess, (state, { dossiers }) => {
    return entiteAdapter.setAll(dossiers?.items ?? [], {
      ...state,
      loading: false,
      errorMessage: null,
      totalElements: dossiers?.totalElements ?? 0,
    });
  }),
  on(MesDossiersActions.getDossiersBySearchCriteriaFailure, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
  })),
  on(MesDossiersActions.updateDossiersSelectionnes, (state, { dossier }) => {
    const isSelected = state.dossiersSelectionnes.some(d => d.id === dossier.id);

    return {
      ...state,
      dossiersSelectionnes: isSelected
        ? state.dossiersSelectionnes.filter(d => d.id !== dossier.id)
        : [...state.dossiersSelectionnes, dossier],
    };
  }),
  on(MesDossiersActions.resetDossiersSelectionnes, (state) => ({
    ...state,
    dossiersSelectionnes: []
  })),
  on(MesDossiersActions.resetForm, (state) => ({
    ...initialState,
    isFactureToDelete: state.isFactureToDelete
  })),
  on(MesDossiersActions.isLoading, (state, { isLoading }) => ({
    ...state,
    isLoading
  })),
    on(MesDossiersActions.deleteFactureAfterNewDossier, (state, { isFactureToDelete }) => ({
      ...state,
      isFactureToDelete
    }))
);

export const mesDossiersFeature = createFeature({
  name: 'mesDossiers',
  reducer: mesDossiersReducers,
});
